import {useEffect} from 'react';
import {useUserConsent} from '@tempo/cookie';

// Sets minimal consent so the CDP gate opens without showing the GDPR banner.
// Use on pages that have their own consent mechanism (e.g. ai-music-detector.deezer.com).
export const ConsentFallback: React.FC = () => {
	const {setConsentSettings} = useUserConsent();

	useEffect(() => {
		setConsentSettings({
			consentString: '',
			statistics: 0,
			targetedAdvertising: 0,
		});
	}, [setConsentSettings]);

	return null;
};
